import { useSwitch, mergeProps, useFocusRing, VisuallyHidden } from 'react-aria';
// do we need to use another package or just manage ToggleState with useState?
import { useToggleState } from 'react-stately';
import { useRef } from 'react';
import cx from 'classix';

export const Toggle = (props: {
  size: 'sm' | 'md';
  children: string;
  description: string;
  onChange: (value: boolean) => void;
  initialValue?: boolean;
  isDisabled?: boolean;
  name?: string;
  value?: string;
}) => {
  const state = useToggleState(props);
  const ref = useRef(null);
  const { inputProps } = useSwitch(props, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();
  return (
    <div className='flex-col'>
      <label
        className={cx(
          `flex items-center gap-x-2 text-${props.size} font-medium text-gray-500`,
          props.size === 'sm' ? 'gap-x-2' : 'gap-x-3',
        )}
      >
        <VisuallyHidden>
          <input {...mergeProps(inputProps, focusProps)} ref={ref} />
        </VisuallyHidden>
        <div
          className={cx(
            'relative flex items-center rounded-full transition-colors',
            props.size === 'sm' ? 'h-5 min-w-9 w-9' : 'h-6 min-w-11 w-11',
            state.isSelected ?
              `bg-brand-500 ${!props.isDisabled && 'hover:bg-brand-100'}`
            : `bg-gray-200 ${!props.isDisabled && 'hover:bg-gray-100'}`,
            isFocusVisible && state.isSelected && 'ring-brand',
            isFocusVisible && !state.isSelected && 'ring-gray-secondary bg-gray-200',
            props.isDisabled && 'bg-gray-200',
          )}
        >
          <span
            className={cx(
              'inline-block  transform rounded-full transition-transform shadow-sm',
              props.size === 'sm' ? 'h-4 w-4' : 'h-5 w-5',
              !state.isSelected && 'translate-x-0.5',
              state.isSelected && props.size === 'sm' && 'translate-x-[1.125rem]',
              state.isSelected && props.size === 'md' && 'translate-x-[1.375rem]',
              props.isDisabled ? 'bg-gray-100' : 'bg-white',
            )}
          />
        </div>
        {props.children}
      </label>
      <div
        className={cx(
          `text-${props.size} font-normal text-gray-400`,
          props.size === 'sm' ? 'ml-11' : 'ml-14',
        )}
      >
        {props.description}
      </div>
    </div>
  );
};
